import { useState, useEffect } from 'react';
import { fetchMemberEventSessions } from '@general/api/eventAPI';

const useMemberEventSessions = ({ memberId, eventCode }) => {
    const [memberEventSessions, setMemberEventSessions] = useState([]);

    useEffect(() => {
        if (!memberId || !eventCode) return;

        const fetchData = async () => {
            const response = await fetchMemberEventSessions({
                memberId,
                eventCode,
            });

            setMemberEventSessions(response?.data?.data);
        };

        fetchData();
    }, [eventCode, memberId]);

    return { memberEventSessions };
};

export default useMemberEventSessions;
